import React, { useState, useEffect, useRef } from "react";
import closeIcon from "../../Assets/Icons/close.png";
import DateInput from "../../Components/DateInput";
import Dropdown from "../../Components/Dropdown";
import { logFrontendException } from "../../Utils/Exception"; // Importing the exception logger
import { postData } from "../../ApiServices/ApiService"; // Importing the API call
import Loader from "../../Components/Loader";
import { ORG_LEAVE_REQUEST_ADD, ORG_DISBURSEMENT_LIST_FILTER,ORG_DISBURSEMENT_APPROVALS } from "../../ApiServices/BaseURL";
import Input from "../../Components/Input";
import { convertGMTToLocal,getLocalDateTime } from "../../Utils/Validation";
import { useTheme } from "../../GlobalContext/GlobalContext";

const RequestDisbursementModal = ({ isOpen, onClose, editData, page, onValueChange }) => {
    console.log('disbursement list radio', editData)
    const [startDate, setStartDate] = useState("");
    const [expanseAmount, setExpanseAmount] = useState("");
    const [requestAmount, setRequestAmount] = useState("");
    const [approvedAmount, setApprovedAmount] = useState("");
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [startDateError, setStartDateError] = useState('');
    const [endDateError, setEndDateError] = useState('');
    const [leaveTypeError, setLeaveTypeError] = useState('');
    const [loading, setLoading] = useState(false); // For loading state
    const [actionType, setActionType] = useState(""); // "approve" or "reject"
    const [rejectReason, setRejectReason] = useState(""); // rejection reason
    const [isFormLocked, setIsFormLocked] = useState(false); // disable fields when rejecting
    const [approvalError, setApprovalError] = useState('');
    const [approvalSuccess, setApprovalSuccess] = useState('');
    const [approvalLoading, setApprovalLoading] = useState(false);
    const [approvedBy, setApprovedBy] = useState("");
    const [availableAmount, setAvailableAmount] = useState("");
    const { setIsLoginPopup } = useTheme();
    const dropdownRefs = useRef({}); // Ref for dropdown
    const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
    const storedUserId = storedUserInfo?.emp_id;
    const pageName = "RequestDisbursementModal"; // Page name for logging


    useEffect(() => {
        if (isOpen && editData && page === 'disApproval') {
            console.log("editData in disbursement", editData);

            const startDate = convertGMTToLocal(editData?.expense_date, 'dd/MM/yyyy');
            setStartDate(startDate);

            setExpanseAmount(editData?.dis_available_amt);
            setRequestAmount(editData?.dis_request_amt);
            //   setApprovedAmount(editData?.amount || "");
        } else {
            console.log("editData in disbursement", editData);

            const startDate = convertGMTToLocal(editData?.expense_date, 'dd/MM/yyyy');
            setStartDate(startDate);

            setExpanseAmount(editData?.dis_available_amt);
            setApprovedBy(editData?.approved_by_name)
            setAvailableAmount(editData?.dis_available_amt);
            //   setApprovedAmount(editData?.amount || "");
        }
    }, [isOpen, editData]);

    const handleClose = () => {
        setError('');
        setStartDateError('');
        setEndDateError('');
        setLeaveTypeError('');
        onClose();
    }

    const clearFeilds = () => {
        setError('');
        setStartDateError('');
        setEndDateError('');
        setLeaveTypeError('');
        setStartDate('');
    }

    const handleSubmit = async () => {
        try {
            // Clear previous errors
            setError('');
            // Prepare the payload
            const payload = {
                action_type: 'reject_disbursement',
                emp_id_auth: storedUserId,
                reject_reason: rejectReason,
                disburse_id: editData?.disburse_id
            };

            setLoading(true); // Show the loader

            // Make the API call (dummy endpoint for now)
            const response = await postData(ORG_DISBURSEMENT_APPROVALS, payload);
            const responseData = await response.json();

            // Handle the response
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        // Successfully submitted
                        setError('')
                        setSuccess(responseData?.info);
                        clearFeilds();
                        setTimeout(() => {
                            handleClose();
                            onValueChange();
                        }, 3000);
                    } else {
                        setError(responseData?.info || 'Failed to add disbursement rejection request. Please try again later.');
                        logFrontendException(storedUserId, pageName, "handleSubmit", responseData?.info || '');
                    }
                } else {
                    setError(responseData?.info || 'Failed to add disbursement rejection request. ');
                    logFrontendException(storedUserId, pageName, "handleSubmit", responseData || '');
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                    setError('Unauthorized access. Your session may have expired. Please log in again.');
                    setIsLoginPopup(true)
                    //  Log exception to backend (User Id,Page Name,Method Name,Response)
                    logFrontendException(storedUserId, pageName, "handleSubmit", responseData || '');
                        
                } else {
                // Handle unexpected or network errors
                setError('Unexpected error occurred. Please try again later.');
                logFrontendException(storedUserId, pageName, "handleSubmit", response || '');
            }
        } catch (err) {

            // An error occurred in setting up the request
            setError(`Failed to submit disbursement rejection request. Please check your network connection and try again.`);
            // Log the error
            logFrontendException(storedUserId, pageName, "handleSubmitCatch", err || '');
        } finally {
            setLoading(false); // Hide the loader
        }
    };

    const approveRequest = async () => {
        try {
            // Clear previous errors
            setApprovalError('');
            setStartDateError('');
            setEndDateError('');
            setLeaveTypeError('');

            // Validate fields
            if (!startDate) {
                setStartDateError("Start date is required.");
                return;
            }

            const approvedAmt = parseFloat(approvedAmount);
            const requestAmt = parseFloat(requestAmount);

            // Amount validations
            if (isNaN(requestAmt)) {
                setApprovalError("Approved amount is required.");
                return;
            }

            if (requestAmt < 0) {
                setApprovalError("Request amount cannot be negative.");
                return;
            }

            if (requestAmt > availableAmount) {
                setApprovalError("Request amount cannot be more than available amount.");
                return;
            }

            // Prepare the payload
            const payload = {
                action_code: "disbursement_request",
                emp_id_auth: storedUserId,
                disburse_id:editData?.disburse_id,
                dis_request_amt:requestAmount,
                dis_available_amt:availableAmount,
                expense_date:startDate
            }

            
            console.log("payload in Disbursements request Mpdal", payload)

            // return

            setApprovalLoading(true); // Show the loader

            const response = await postData(ORG_DISBURSEMENT_LIST_FILTER, payload);
            const responseData = await response.json();

            // Handle the response
            if (response?.status === 200) {
                if (responseData?.status_code === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        // Successfully submitted
                        setApprovalError('')
                        setApprovalSuccess(responseData?.info);
                        clearFeilds();
                        setTimeout(() => {
                            handleClose();
                            onValueChange();
                        }, 3000);
                    } else {
                        setApprovalError(responseData?.info || 'Failed to approve disbursement request. Please try again later.');
                        logFrontendException(storedUserId, pageName, "approveRequest", responseData?.info || '');
                    }
                } else {
                    setApprovalError(responseData?.info || 'Unable to approve disbursement request.');
                    logFrontendException(storedUserId, pageName, "approveRequest", responseData || '');
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setApprovalError('Unauthorized access. Your session may have expired. Please log in again.');
                setIsLoginPopup(true)
                // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response)
                logFrontendException(storedUserId, pageName, "approveRequest", responseData || '');
                    
            } else {
                // Handle unexpected or network errors
                setApprovalError('Unexpected error occurred. Please try again later.');
                logFrontendException(storedUserId, pageName, "approveRequest", response || '');
            }
        } catch (err) {

            // An error occurred in setting up the request
            setApprovalError(`Failed to approve disbursement request. Please check your network connection and try again.`);
            // Log the error
            logFrontendException(storedUserId, pageName, "approveRequestCatch", err || '');

        } finally {
            setApprovalLoading(false); // Hide the loader
        }
    };

    const resetForm = () => {
        setStartDate("");
        setRequestAmount('')
        setExpanseAmount('')
        setApprovedAmount('')
    };

    if (!isOpen) return null;
    // console.log('new Date().toISOString().slice(0, 16)', new Date().toISOString().slice(0, 16),getLocalDateTime())

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <button className="close-button" onClick={onClose}>
                    <img src={closeIcon} alt="Close" style={{ width: 15, height: 15 }} />
                </button>
                <h2 className="modal-title">Request Disbursement</h2>
                <hr className="title-divider" />
                <div className={`form-section ${isFormLocked ? "form-disabled" : ""}`}>
                    <div className="form-grid" style={{ columnGap: '35px' }}>
                        {/* Date Inputs */}
                        <div>
                            <label style={{ fontSize: '12px', color: '#343C44' }}>Expense Date</label>
                            <Input
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                                errorMessage={startDateError}
                                isEdit={false}
                            />
                        </div>

                        <div>
                            <label style={{ fontSize: '12px', color: '#343C44' }}>Approved by</label>
                            <Input
                                value={approvedBy}
                                onChange={(e) => setApprovedBy(e.target.value)}
                                errorMessage={endDateError}
                                isEdit={false}
                            />
                        </div>
                        <div>
                            <label style={{ fontSize: '12px', color: '#343C44' }}>Available Amount</label>
                            <Input
                                value={availableAmount}
                                onChange={(e) => setAvailableAmount(e.target.value)}
                                errorMessage={endDateError}
                                isEdit={false}
                            />
                        </div>
                        <div>
                            <label style={{ fontSize: '12px', color: '#343C44' }}>Requested Amount</label>
                            <Input
                                value={requestAmount}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setRequestAmount(value);
                                }}
                                errorMessage={endDateError}
                                inputType='number'
                            />
                        </div>
                    </div>

                    {/* Comment (Outside form-grid) */}

                    <hr className="divider" />
                    <div className="tasksScreen-filter-buttons">
                        <button
                            onClick={approveRequest}
                            className="add-client-button"
                            style={{
                                opacity: approvalLoading ? 0.5 : 1,
                                cursor: approvalLoading ? 'not-allowed' : 'pointer',
                            }}
                            disabled={approvalLoading}
                        >
                            <span style={{ paddingRight: approvalLoading ? 10 : 0 }}>
                                <Loader loading={approvalLoading} color={'#FFFFFF'} size='small' />
                            </span>
                            Request
                        </button>
                        {/* <button
                            onClick={() => {
                                setActionType("reject");
                                setIsFormLocked(true);
                            }}
                            className="tasksScreen-cancel-button"
                            disabled={approvalLoading}
                        >
                            Reject
                        </button> */}
                        <button
                            className="cancel-button"
                            onClick={() => {
                                resetForm();
                                onClose();
                            }}
                        >
                             No
                        </button>
                        {approvalSuccess && <div className="list-success-msg" style={{ marginBottom: '1px' }}>{approvalSuccess} </div>}
                        {approvalError && <div className="list-error-msg" style={{ marginBottom: '1px' }}>{approvalError}</div>}
                    </div>
                </div>
                {actionType === "reject" && (
                    <div style={{ marginTop: "10px" }}>
                        <label style={{ fontSize: "12px", color: "#343C44" }}>Reject Reason</label>
                        <Input
                            value={rejectReason}
                            onChange={(e) => setRejectReason(e.target.value)}
                            placeholder="Enter reject reason"
                            className="form-input"
                            searchBoxWidth={260}
                        />
                        <div className="tasksScreen-filter-buttons">
                            <button
                                onClick={handleSubmit}
                                className="add-client-button"
                                style={{
                                    opacity: loading ? 0.5 : 1,
                                    cursor: loading ? 'not-allowed' : 'pointer',
                                }}
                                disabled={loading}
                            >
                                <span style={{ paddingRight: loading ? 10 : 0 }}>
                                    <Loader loading={loading} color={'#FFFFFF'} size='small' />
                                </span>
                                Submit
                            </button>
                            <button
                                className="cancel-button"
                                onClick={() => {
                                    setActionType("approve");
                                    setIsFormLocked(false);
                                }}
                            >
                                Cancel
                            </button>
                            {success && <div className="list-success-msg" style={{ marginBottom: '1px' }}>{success} </div>}
                            {error && <div className="list-error-msg" style={{ marginBottom: '1px' }}>{error}</div>}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default RequestDisbursementModal;
